import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { WINDOW } from '@upr-web-primer/window';
class LockScrollService {
  constructor(document, window, renderer) {
    this.document = document;
    this.window = window;
    this.renderer = renderer;
    this._document = this.document;
    this._window = this.window;
    this._renderer = this.renderer.createRenderer(null, null);
  }
  /**
   * Lock an element from scrolling. Defaults to locking the body element, using the 'overflow' style.
   * @param [element] Any HTML element. Fallback is the body element.
   * @param [style] Lock both axes, or lock y, or x axis. Defaults to lock both axes.
   */
  lockScroll(element, style) {
    this._renderer.setStyle(element ? element : this._document.body, style ? style : 'overflow', 'hidden');
    if (this._window.innerWidth < 768) {
      this.scrollPos = this._window.scrollY;
    }
  }
  /**
   * Unlock a scroll locked element. Defaults to unlocking the body element, using the 'overflow' style.
   * @param [element] Any HTML element. Fallback is the body element.
   * @param [style] Lock both axes, or lock y, or x axis. Defaults to lock both axes.
   */
  unlockScroll(element, style) {
    this._renderer.removeStyle(element ? element : this._document.body, style ? style : 'overflow');
    if (this._window.innerWidth < 768) {
      this._window.scrollTo(0, this.scrollPos);
    }
  }
  static {
    this.ɵfac = function LockScrollService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LockScrollService)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(WINDOW), i0.ɵɵinject(i0.RendererFactory2));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LockScrollService,
      factory: LockScrollService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LockScrollService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: i0.RendererFactory2
  }], null);
})();
class LockScrollModule {
  static {
    this.ɵfac = function LockScrollModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LockScrollModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LockScrollModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [LockScrollService]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LockScrollModule, [{
    type: NgModule,
    args: [{
      providers: [LockScrollService]
    }]
  }], null, null);
})();

/*
 * Public API Surface of lock-scroll
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LockScrollModule, LockScrollService };
